import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class NgSelectMultipleService {

  constructor(
    @Inject('NG_SELECT_MULTIPLE_SHOWLIMIT') private showlimit: number = 2,
    @Inject('NG_SELECT_MULTIPLE_HEADER') private Header: boolean = true,
    @Inject('NG_SELECT_MULTIPLE_FOOTER') private Footer: boolean = true,
    @Inject('NG_SELECT_MULTIPLE_MARK_FIRST') private markFirst: boolean = false,
    @Inject('NG_SELECT_MULTIPLE_OPEN_WHEN_FOCUS') private openWhenFocus: boolean = false,
    @Inject('NG_SELECT_MULTIPLE_VALIDATOR_MESSAGE') private validatorMessage: boolean = false,
    @Inject('NG_SELECT_MULTIPLE_TOOLTIP_MESSAGE') private tooltipMessage: boolean = true,
    @Inject('NG_SELECT_MULTIPLE_VALIDATOR_ALERT') private validatorAlert: boolean = false,
    @Inject('NG_SELECT_MULTIPLE_SUBMITTED') private submitted: boolean = true,
    @Inject('NG_SELECT_MULTIPLE_APPEND_TO') private appendTo: string = "body",
    @Inject('NG_SELECT_MULTIPLE_LOADING_TEXT') private loadingText: string = "Cargando...",
  ) {
  }

  public getShowlimit(): number {
    return this.showlimit;
  }
  public getHeader(): boolean {
    return this.Header;
  }
  public getFooter(): boolean {
    return this.Footer;
  }
  public getMarkFirst(): boolean {
    return this.markFirst;
  }
  public getOpenWhenFocus(): boolean {
    return this.openWhenFocus;
  }
  public getValidatorMessage(): boolean {
    return this.validatorMessage;
  }
  public getTooltipMessage(): boolean {
    return this.tooltipMessage;
  }
  public getValidatorAlert(): boolean {
    return this.validatorAlert;
  }
  public getSubmitted(): boolean {
    return this.submitted;
  }
  public getAppendTo(): string {
    return this.appendTo;
  }
  public getLoadingText(): string {
    return this.loadingText;
  }
  
}